import "core-js/modules/es.error.cause.js";
import { isCardNo } from '@/utils/validate';
import { getBlackList, addBlackList, deleteBlackList, blacklistExport } from './request';
import batchImportData from './batchImportData';
import { blackTypeEnums, blackStatusEnums } from '../utils';
import { downloadFileFun } from '@/utils/public';
export default {
  data() {
    return {
      form: {
        blacklistType: undefined,
        // entityInfo: '',
        idNo: '',
        companyName: ''
      },
      columns: [{
        dataIndex: 'index',
        width: 80,
        slots: {
          title: '序号'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'idx'
        }
      }, {
        dataIndex: 'blacklistType',
        width: 200,
        slots: {
          title: '黑名单类型'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'blacklistType'
        }
      }, {
        dataIndex: 'companyName',
        width: 200,
        slots: {
          title: '企业名称'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'companyName'
        }
      }, {
        dataIndex: 'idNo',
        width: 200,
        slots: {
          title: '人员证件号码'
        },
        align: 'center',
        scopedSlots: {
          customRender: 'idNo'
        }
      }, {
        width: 200,
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center'
      }],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      blackForm: {
        blacklistType: undefined,
        // entityInfo: ''
        idNo: '',
        companyName: ''
      },
      addVisible: false,
      saveLoading: false,
      importVisible: false,
      blackStatusEnums,
      blackTypeEnums,
      exportLoading: false
    };
  },
  components: {
    batchImportData
  },
  computed: {
    messageRules() {
      return {
        blacklistType: [{
          required: true,
          message: this.$t('请选择') + this.$t('黑名单类型'),
          trigger: 'change'
        }],
        companyName: [{
          required: true,
          message: this.$t('请输入企业名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 20,
          message: this.$t('请输入1-20字符'),
          trigger: 'blur'
        }],
        idNo: [{
          required: true,
          message: this.$t('请输入人员证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }]
      };
    }
  },
  mounted() {
    this.getBlackList();
  },
  methods: {
    refreshList() {
      this.getBlackList();
    },
    validateCard(rule, idcard, callback) {
      if (!isCardNo(idcard) || idcard == '') {
        callback(new Error(this.$t('请输入18位大陆身份证号')));
      } else {
        callback();
      }
    },
    batchImport() {
      this.importVisible = true;
    },
    onSearch() {
      this.pagination.current = 1;
      this.getBlackList();
    },
    reset() {
      this.$refs.form.resetFields();
      this.pagination.current = 1;
      this.getBlackList();
    },
    exportData() {
      this.exportLoading = true;
      console.log(this.blackForm, 'this.blackForm');
      let params = {
        blacklistType: this.blackForm.blacklistType || '',
        companyName: this.blackForm.companyName || '',
        idNo: this.blackForm.idNo || ''
      };
      blacklistExport(params).then(res => {
        // this.$confirm({
        //   icon: () => <a-icon type="check-circle" theme="twoTone" />,
        //   title: this.$t('导出提示'),
        //   content: that.$t('导出任务已生成，请稍后查看导出附件'),
        //   okText: that.$t('确认'),
        //   cancelText: that.$t('取消'),
        //   onOk() {}
        // });
        // let fileName = decodeURIComponent(
        //   res.headers['content-disposition']
        //     .split(';')[2]
        //     .split('=')[1]
        //     .replace(/^\"|\"$/g, '')
        //     .replace(/utf-8''/, '')
        // );
        let fileName = '黑名单数据';
        console.log(fileName, 'fileName');
        downloadFileFun(res, 'application/vnd.ms-excel', fileName);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    getBlackList() {
      var _this$form$blacklistT, _this$form$idNo, _this$form$companyNam;
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        blacklistType: ((_this$form$blacklistT = this.form.blacklistType) === null || _this$form$blacklistT === void 0 ? void 0 : _this$form$blacklistT.trim()) || '',
        idNo: ((_this$form$idNo = this.form.idNo) === null || _this$form$idNo === void 0 ? void 0 : _this$form$idNo.trim()) || '',
        companyName: ((_this$form$companyNam = this.form.companyName) === null || _this$form$companyNam === void 0 ? void 0 : _this$form$companyNam.trim()) || ''
        // entityInfo: this.form.entityInfo.trim()
      };
      console.log(params, 'params');
      getBlackList(params).then(res => {
        if (res && res.items) {
          console.log(res, 'getBlackList');
          this.data = res.items || [];
          this.pagination.total = Number(res.totalNum) || 0;
        }
      });
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getBlackList();
    },
    openAddModal(record) {
      this.addVisible = true;
    },
    saveAdd() {
      if (this.saveLoading) return;
      this.$refs.addRef.validate(valid => {
        if (valid) {
          let entityInfo = '';
          if (this.blackForm.blacklistType === 'company') {
            entityInfo = this.blackForm.companyName.trim();
          } else if (this.blackForm.blacklistType === 'person') {
            entityInfo = this.blackForm.idNo.trim();
          }
          let params = {
            blacklistType: this.blackForm.blacklistType.trim(),
            entityInfo
          };
          this.saveLoading = true;
          addBlackList(params).then(res => {
            if (res && res.blacklistId) {
              this.$message.success(this.$t('新增成功'));
              this.closeAddVisible();
              this.getBlackList();
            }
          }).finally(() => {
            this.saveLoading = false;
          });
        }
      });
    },
    closeAddVisible() {
      this.$refs.addRef.resetFields();
      this.addVisible = false;
      this.blackForm = {
        blacklistType: undefined,
        entityInfo: ''
      };
    },
    handleDelete(record) {
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确认删除该条信息吗？'),
        onOk: () => {
          deleteBlackList({
            id: record.id
          }).then(res => {
            if (res) {
              this.$message.success(this.$t('删除成功'));
              this.getBlackList();
            }
          });
        },
        onCancel() {}
      });
    }
  }
};